import { render, staticRenderFns } from "./UiCheckboxRevenue.vue?vue&type=template&id=4ec1606b&scoped=true&"
import script from "./UiCheckboxRevenue.vue?vue&type=script&lang=js&"
export * from "./UiCheckboxRevenue.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckboxRevenue.vue?vue&type=style&index=0&id=4ec1606b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec1606b",
  null
  
)

export default component.exports